// src/components/Admin/SalasCmp/UserFreeSalasItemSalas.jsx
import React from "react";
import { Button, Card, Image, Icon } from "semantic-ui-react";
import { useNavigate } from "react-router-dom";
import { MozillaHubRoomsApi } from "../../../../../api";
import { useAuth } from "../../../../../hooks";
import "./UserFreeSalasItemSalas.scss";

const mozillaHubRoomsApi = new MozillaHubRoomsApi();

export function UserFreeSalasItemSalas({ scene }) {
  const navigate = useNavigate();
  const { accessToken } = useAuth();

  const handleInfoClick = () => {
    navigate(`/userfree/guia/${scene.refId}`);
  };

  // El usuario free abre la urlsala directa (no crea sala, no pasa por
  // /roomshub/load): la apertura solo se ve en el dashboard si la anotamos.
  const handleEnterClick = () => {
    mozillaHubRoomsApi.trackRoomOpen(accessToken, {
      sceneRefId: scene.refId,
      url: scene.urlsala,
      title: scene.title,
      source: "free_salas",
    });
  };

  return (
    <Card className="scene-card">
      <Image src={scene.bannertopUrl} wrapped ui={false} />
      <Card.Content className="content">
        <Card.Header className="header">{scene.title}</Card.Header>
        <Card.Meta className="meta">
          {scene.subcategory?.map((sub, index) => (
            <span key={index} className="subcategory">
              {sub}
            </span>
          ))}
        </Card.Meta>
      </Card.Content>
      <Card.Content extra className="actions">
        <Button
          primary
          size="small"
          as="a"
          href={scene.urlsala}
          target="_blank"
          onClick={handleEnterClick}
        >
          Entrar
        </Button>
        <Button secondary size="small" onClick={handleInfoClick}>
          <Icon name="info circle" />
        </Button>
      </Card.Content>
    </Card>
  );
}
